import React, { Component } from 'react';

export default class Interstitial extends Component {
  static propTypes = {

  };

  render() {
    return (
      <div className="common-interstitial">
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/Interstitial.js